import { render, staticRenderFns } from "./ExpandableText.vue?vue&type=template&id=1203a399&scoped=true&"
import script from "./ExpandableText.vue?vue&type=script&lang=ts&"
export * from "./ExpandableText.vue?vue&type=script&lang=ts&"
import style0 from "./ExpandableText.vue?vue&type=style&index=0&id=1203a399&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1203a399",
  null
  
)

export default component.exports